var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#513764;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2183",
    className: "st0",
    d: "M30,0h40c16.6,0,30,13.4,30,30v70l0,0H30C13.4,100,0,86.6,0,70V30C0,13.4,13.4,0,30,0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.6,25.9c0.6,0,1.3,0.2,1.7,0.7l31,27.6c0.5,0.5,0.8,1.2,0.8,1.9c0,1.4-1.1,2.5-2.5,2.5H57.4l6.4,12.9 c0.9,1.8,0.2,4-1.6,4.9c-1.8,0.9-4,0.2-4.9-1.6l-6.6-13.2l-9.4,10.7c-0.5,0.5-1.2,0.8-1.9,0.8c-1.4,0-2.5-1.1-2.5-2.5v-42 C37,27.1,38.2,25.9,39.6,25.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructPurple);
export default __webpack_public_path__ + "static/media/Instruct_Purple.abbb2cd34de8ace551478f335fa8e362.svg";
export { ForwardRef as ReactComponent };